module.exports = __webpack_public_path__ + "static/img/advantage.97bd582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/recombinant-cells-protein-expression/advantage.png
// module id = yILA
// module chunks = 1